<template>
    <div class="bar-wrap">
        <div class="index-bar">
            <a v-for="bar in bars" :key="bar" class="item" :href="'#' + bar.replace(/\s+/g, '')" @click.prevent="anchorJump('#' + bar)">{{ bar }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IndexBar',
    components: {},
    props: {
        bars: {
            type: [],
            default: () => []
        }
    },
    methods: {
        anchorJump(target) {
            const str = target.replace(/\s+/g, '')
            if (this.$parent.$el.querySelector(str)) {
                this.$parent.$el.querySelector(str).scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bar-wrap {
    background: #f5f5f5;
    border-bottom: solid 1px #f0f0f0;
    height: 100px;
    .index-bar {
        display: flex;
        align-items: center;
        cursor: pointer;
        width: 100vw;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        .item {
            padding: 30px 0;
            margin: 0 25px 0 40px;
            font-weight: 400;
            font-size: 28px;
            color: #333;
            position: relative;
            white-space: nowrap;
            &:active {
                font-weight: bold;
                color: #ce0e2d;
                position: relative;
                &::before {
                    content: ' ';
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%, 20px);
                    top: 50%;
                    width: 40px;
                    background: #ce0e2d;
                    border-radius: 10px;
                    height: 6px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/components/index-bar.vue